import days from '@anm/constants/days';

const getDateDay = (date: string | number) => {
  const dateObj = new Date(date);
  const dateVal = dateObj.getDate();
  const dayVal = days[dateObj.getDay()].slice(0, 3);

  return [dateVal, dayVal] as const;
};

export default getDateDay;
